<template lang="pug">
    div(class="_btngroup")
        slot
</template>

<script>
    /**
     * A group of buttons with relevant spacing
     */
    export default {
        name: 'ib-button-group'
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._btngroup {
        &.wgrow {
            display: flex;
            flex-direction: row;
            ._btn {
                flex: 1 1 auto;
            }
        }
    }
</style>

<ib-example id="basic" name="Basic">
    <template lang="pug">
        ib-button-group
            ib-button Button1
            ib-button Button2
            ib-button Button3
            ib-button Button4
    </template>
</ib-example>

<ib-example id="wgrow" name="Width Grow">
    <template lang="pug">
        ib-button-group(class="wgrow")
            ib-button Button1
            ib-button Button2
            ib-button Button3
            ib-button Button4
    </template>
</ib-example>
